







import {Component, Prop, Vue} from "@zoovu/runner-browser-api";

@Component({})
export default class InfoText extends Vue {

    @Prop()
    text: string;
}
